import { ChangeEvent } from 'react'
import { FilterDefinition, SelectedFilter } from '../api/dashboard';
export enum SelectionAction {
    Add,
    Remove,
    Change,
    Clear
}
export interface DropDownOption {
    label: string;
    value: string;
}
export interface SelectionChangeEvent {
    action: SelectionAction,
    name: string,
    value: string

}
interface FilterProps {
    selected: SelectedFilter[],
    filterDefinitions: FilterDefinition[] | null
    onSelectionChange: (event: SelectionChangeEvent) => any
}
const Filter = ({ selected, filterDefinitions, onSelectionChange }: FilterProps) => {
    const handleDateChange = (event: ChangeEvent<HTMLInputElement>, type: string) => {
        onSelectionChange({ action: SelectionAction.Change, name: type, value: event.currentTarget.value })
    }
    // Picking a characteristic adds its row straight away; the new row's
    // select takes focus so the value is the next thing chosen.
    const add = (event: ChangeEvent<HTMLSelectElement>) => {
        const name = event.currentTarget.value;
        event.currentTarget.value = "";
        if (name) {
            onSelectionChange({ action: SelectionAction.Add, name, value: "" });
        }
    };
    const remove = (item: SelectedFilter) => {
        onSelectionChange({ action: SelectionAction.Remove, name: item.name, value: "" })
    };
    const handleSubChange = (event: ChangeEvent<HTMLSelectElement>, selected: SelectedFilter) => {
        onSelectionChange({ action: SelectionAction.Change, name: selected.name, value: event.currentTarget.value })
    }
    const startDate = selected.find(i => i.name === "StartDate");
    const endDate = selected.find(i => i.name === "EndDate");
    // In the order the API defines them, not the order they were added.
    const active = (filterDefinitions ?? [])
        .map(definition => ({ definition, filter: selected.find(i => i.name === definition.id) }))
        .filter((a): a is { definition: FilterDefinition, filter: SelectedFilter } => a.filter != null);
    const available = (filterDefinitions ?? []).filter(d => !selected.some(i => i.name === d.id));
    const hasAny = selected.length > 0;

    return (
        <div className="fd-filters">
            <div className="fd-filters__header">
                <h3 className="fd-filters__title"><i className="bi bi-funnel me-2" aria-hidden="true" />Filter the data</h3>
                {hasAny && (
                    <button type="button" className="btn btn-link btn-sm p-0" onClick={() => onSelectionChange({ action: SelectionAction.Clear, name: "", value: "" })}>
                        Clear all filters
                    </button>
                )}
            </div>
            <div className="row g-3">
                <div className="col-sm-6 col-lg-3">
                    <label className="form-label" htmlFor="fd-start-date">From</label>
                    <input id="fd-start-date" className="form-control" type="date" max={endDate?.value}
                        onChange={(event => handleDateChange(event, "StartDate"))} value={startDate?.value ?? ""} />
                </div>
                <div className="col-sm-6 col-lg-3">
                    <label className="form-label" htmlFor="fd-end-date">To</label>
                    <input id="fd-end-date" className="form-control" type="date" min={startDate?.value}
                        onChange={(event => handleDateChange(event, "EndDate"))} value={endDate?.value ?? ""} />
                </div>
                <div className="col-lg-6">
                    <label className="form-label" htmlFor="fd-add-filter">Incident characteristics</label>
                    <select id="fd-add-filter" className="form-select" onChange={add} defaultValue="" disabled={available.length === 0}>
                        <option value="">{available.length === 0 ? 'All characteristics are in use' : 'Add a filter…'}</option>
                        {available.map(item => <option value={item.id} key={item.id}>{item.name}</option>)}
                    </select>
                </div>
            </div>
            {active.length > 0 && (
                <ul className="fd-filters__active row g-3 list-unstyled mb-0">
                    {active.map(({ definition, filter }) => (
                        <li className="col-md-6 col-lg-4" key={definition.id}>
                            <div className={`fd-filter${filter.value ? ' is-set' : ''}`}>
                                <label className="fd-filter__label" htmlFor={`fd-filter-${definition.id}`}>{definition.name}</label>
                                <div className="d-flex gap-2">
                                    <select id={`fd-filter-${definition.id}`} className="form-select form-select-sm" value={filter.value}
                                        onChange={(event) => handleSubChange(event, filter)} autoFocus={!filter.value}>
                                        <option value="">Choose {definition.name.toLowerCase()}…</option>
                                        {definition.values?.map(value => <option value={value} key={value}>{value}</option>)}
                                    </select>
                                    <button type="button" className="btn btn-sm btn-outline-secondary fd-filter__remove" onClick={() => remove(filter)}
                                        aria-label={`Remove the ${definition.name} filter`} title="Remove filter">
                                        <i className="bi bi-x-lg" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
export default Filter;
